module.exports = new __parcel__URL__("../marker-shadow.27763997.png").toString();